export default "__VITE_ASSET__Dnw0gIcn__"